import { DateHandler } from '@angle/utils'
import React, { useContext, useMemo } from 'react'
import {
  Button,
  CenteredSpinner,
  Col,
  Row,
  useToaster
} from 'react-angle-dashboard-components'
import { useMutation } from 'react-query'
import styled from 'styled-components'
import useStep from '../../hooks/use-step'
import { emailService as EmailService } from '../../services'
import { GbsStore } from '../../store'
import { useStepData } from '../../store/selectors'

const Text = styled.h1`
  color: black;
  margin-bottom: 1rem;
`

const OutlineButton = styled.button`
  border: none;
  color: #00406d;
  background: transparent;
  padding: 0;
  text-decoration: underline;
`

const stepKey = 'onboarding'

export const Onboarding = () => {
  const { dispatch } = useContext(GbsStore)
  const stepData = useStepData('enrollment')

  // const [value] = useState<number | null>(stepData?.value || null)

  const { show } = useToaster()
  const sendEmail = useMutation(() => EmailService.sendOnboardingEmail(), {
    onSuccess: () => {
      return show({
        message: 'Email Sent',
        icon: 'icon-correct',
        type: 'success'
      })
    },
    onError: (e: any) => {
      return show({
        message: `${
          e.message || 'Unknown Error'
        }. Please reach out to receive your onboarding information`,
        type: 'danger'
      })
    }
  })

  const stepConfig = useMemo(() => {
    return {
      bottomBar: {
        hidden: true
      },
      topBar: {
        completedPercentage: 100,
        completed: true
      }
    }
  }, [])

  useStep(stepKey, stepConfig, dispatch)

  return (
    <div className="h-100 d-flex flex-column justify-content-center">
      <Row className="d-flex justify-content-center mb-8">
        <Col md={6}>
          <div className="text-center">
            <Text>
              It’s Time To Begin Onboarding
              <span className="text-primary">!</span>
            </Text>
            <p>
              You’ve just been sent an email to start your business onboarding.
              Click the link in that email to begin adding your business
              details.
            </p>
            <p>
              <OutlineButton
                onClick={() => sendEmail.mutate()}
                className="text-primary"
              >
                Didnt receive? Resend Email.
              </OutlineButton>
            </p>
          </div>
        </Col>
      </Row>
      <Row className="d-flex justify-content-center">
        <Col className="p-6" md={8} style={{ backgroundColor: '#f2f5f9' }}>
          <Row className="d-flex justify-content-center">
            <Col xs={10} className="text-center">
              <h3 className="mb-4">What happens next?</h3>
              <p className="mb-4">
                You'll be contacted by your enrollment specialist,{' '}
                <a
                  href="https://calendly.com/gurupreet/self-serve"
                  target="_blank noreferrer"
                  className="text-primary font-weight-bold"
                >
                  Guru
                </a>
                , to walk you through onboarding. After you've finished
                onboarding your business, your employees will automatically be
                sent an email to begin their open enrollment. Your plan is
                scheduled to go live on:
              </p>
              <p>
                <b className="fs-18 mb-4">
                  {stepData?.value ? (
                    DateHandler.formatFullDate(stepData?.value)
                  ) : (
                    <CenteredSpinner />
                  )}
                </b>
              </p>
              <p className="mb-4">
                Additional questions? Schedule additional time with Guru to
                answer any questions or concerns regarding your new plan.
              </p>
              <Button
                variant="primary"
                href={'https://calendly.com/gurupreet/self-serve'}
                target="_blank noreferrer"
              >
                Schedule Time
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default Onboarding
